import type { ReactNode } from 'react'
import React, { createContext, useContext, useMemo } from 'react'

import type { ChartConfig } from './Chart.types'

interface ChartContextValue {
  config: ChartConfig
}

const ChartContext = createContext<ChartContextValue | undefined>(undefined)

export interface ChartProviderProps {
  children: ReactNode
  config: ChartConfig
}

export const ChartProvider = ({ children, config }: ChartProviderProps) => {
  const value = useMemo<ChartContextValue>(() => ({ config }), [config])

  return <ChartContext.Provider value={value}>{children}</ChartContext.Provider>
}

export const useChart = () => {
  const context = useContext(ChartContext)

  if (!context) {
    throw new Error('useChart must be used within a ChartProvider')
  }

  return context
}
